export enum ImpactRatingStatus {
  Active = 'active',
  Archived = 'archived',
}
